module.exports = __webpack_public_path__ + "images/eu_flag-5f82c10a0a81a44c2a937f229c14b40d.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/eu_flag.png
// module id = 206
// module chunks = 0